module.exports = __webpack_public_path__ + "static/media/why_lt.78c9f4d6.vtt";